import type { Identity } from '../types/auth';

export const RELATIONSHIP_PERMISSION = 'argus.identaware';

/** Explicit permission or the usual Argus super-admin override; no development bypass. */
export const canViewRelationships = (identity: Identity | null | undefined): boolean => {
  const permissions = identity?.raw?.custom?.permissions;
  const groups = identity?.raw?.custom?.groups;
  return (Array.isArray(permissions) && permissions.includes(RELATIONSHIP_PERMISSION)) ||
    (Array.isArray(groups) && groups.includes('SPY_Super_admin'));
};
